export const ASSINATURA = 'assinatura';
export const CADASTRO = 'cadastro';
export const CONTATO = 'contato';
export const LOGIN = 'login';
export const TERMO_USO = 'termoUso';
export const EDITAR_MONITORMENTO = 'editarMonitoramento';
export const SELECIONAR_PERFIL = 'selecionarPerfil';
export const SUGERIR_PROCESSOS = 'sugerirProcessos';
export const NPS = 'nps';
export const CONFIRMAR_EMAIL = 'confirmarEmail';
export const NOVO_MONITORAMENTO = 'novoMonitoramento';
